import React from 'react';
import { PapiPremiumFolderData } from '@wix/da-papi-types';
import PremiumGallery from '@wix/da-ds/pkg/Icons/24x24/PremiumGallery';
import FollowingWatchIcon from '@wix/da-ds/pkg/Icons/16x16/FollowingWatch';
import { Props as IconProps } from '@wix/da-ds/pkg/Icons/IconWrap';

export interface Props extends IconProps {
  premiumFolderData?: PapiPremiumFolderData;
}

const PremiumFolderDataIcon: React.FC<Props> = ({
  premiumFolderData,
  ...iconProps
}) => {
  switch (premiumFolderData?.type) {
    case 'paid':
      return <PremiumGallery {...iconProps} />;
    case 'watchers':
      return <FollowingWatchIcon {...iconProps} />;
    default:
      return null;
  }
};

PremiumFolderDataIcon.displayName = 'PremiumFolderDataIcon';

export default PremiumFolderDataIcon;
